import { useExternalScripts } from "@vendor-app/v3/hooks/useExternalScripts";
import Progress from "@vendor-app/v3/components/Onboarding/Progress";
import Store from "@vendor-app/v3/components/Onboarding/Steps/Store/Store";

const POLARIS_SCRIPT = "https://cdn.shopify.com/shopifycloud/polaris-2.0.js";

export function Onboarding(): JSX.Element {
  useExternalScripts([POLARIS_SCRIPT]);

  return (
    <s-page heading="Welcome to Smartrr!">
      <Progress />
      <Store />
    </s-page>
  );
}
